export default __webpack_public_path__ + "static/media/PAYW-Pro-Medium.3ab65dc0.otf";